import { jsx as _jsx } from "react/jsx-runtime";
import { v4 as uuidv4 } from "uuid";
import { MarketingIcon } from "./marketing-icon";
import { SoftwareIcon } from "./software-icon";
import { DevIcon } from "segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/dev-icon.js";
import { CRMIcon, ServiceIcon, WmIcon } from "../../header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/index.js";
import { ProjectManagementIcon } from "./project-management-icon";
import { emailCampaignsIcon } from "segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/email-campaigns-icon";
const productNameToIconMap = {
    core: WmIcon,
    projectManagement: ProjectManagementIcon,
    software: SoftwareIcon,
    marketing: MarketingIcon,
    crm: CRMIcon,
    service: ServiceIcon,
    serviceWhite: ServiceIcon,
    coreWhite: WmIcon,
    softwareWhite: DevIcon,
    crmWhite: CRMIcon,
    marketingCampaigns: emailCampaignsIcon
};
export const ProductIcon = ({ product })=>{
    const IconComponent = productNameToIconMap[product];
    return IconComponent ? /*#__PURE__*/ _jsx(IconComponent, {
        id: uuidv4()
    }) : null;
};
